define('controllers/searchcontrol',[],function() {
	return function() {
		$.ui.autocomplete.prototype._renderMenu = function (ul, items) {
			var self = this;
			$.each(items, function (index, item) {
				// here we define how many results to show
				if (index < 15) {
					self._renderItemData(ul, item); 
				}
			});
		};

		window.SearchControl_Utils = { 
				loading: function(){$(this).addClass('working');},
				doneLoading: function(){$(this).removeClass('working');}
		};
		
		//iterate over all instances and initiate them
		$.each(window.ServerData.feData.SearchControlInstances, function(index, instanceData) {
			initiateSearchControl(instanceData);
		});
	};
	
	function initiateSearchControl(instance) {
		window[instance.eventHandlerClassName] = {
			SetValue: function (event, ui) {
				var item = window[instance.eventHandlerClassName].getItem.call(this, ui);
				$(this).val(item.label).attr(instance.data_selectedValue, item.value);
				window[instance.eventHandlerClassName].onValueSet.call(this, item);
				return false;
			},
			onValueSet: function (item) {/*reset this to do anything, upon box value getting set.*/},
			onChange: function (item) {/*reset this to do an ajax request or whatever*/},
			getItem: function (ui) {
				return ui.item ? ui.item : { value: '0', label: $(this).val() };
			}
		};

		$(function () {
			$(instance.boxSelector).autocomplete({
				source: instance.dataUrl || instance.data,
				search: SearchControl_Utils.loading,
				response: SearchControl_Utils.doneLoading, 
				delay: 100,
				focus: window[instance.eventHandlerClassName].SetValue,
				select: window[instance.eventHandlerClassName].SetValue,
				change: function (event, ui) {
					window[instance.eventHandlerClassName].SetValue.call(this, event, ui);
					window[instance.eventHandlerClassName].onChange.call(this, window[instance.eventHandlerClassName].getItem.call(this, ui));
					return false;
				}
			}).on('keyup', function () {
				//if we empty the box, set to initial value...
				if ($(this).val().trim() == '') {
					window[instance.eventHandlerClassName].SetValue.call(this, undefined, { item: null });
				}
			});
		});
	}
});
